import Container from './Container'
import { SITE_NAME } from '@/lib/constants'

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-20">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 py-12">
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">{SITE_NAME}</h3>
            <p className="text-gray-500 text-sm">
              Журнал о бизнесе, людях и трендах. Актуальные новости, экспертные мнения и практические советы.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">
              Навигация
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-500 hover:text-gray-800 transition-colors text-sm">
                  Главная
                </a>
              </li>
              <li>
                <a href="/issues" className="text-gray-500 hover:text-gray-800 transition-colors text-sm">
                  Выпуски
                </a>
              </li>
              <li>
                <a
                  href="/partners"
                  className="text-gray-500 hover:text-gray-800 transition-colors text-sm"
                >
                  Наши партнеры
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-500 hover:text-gray-800 transition-colors text-sm">
                  О нас
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-500 hover:text-gray-800 transition-colors text-sm">
                  Контакты
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">
              Контакты
            </h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li>Волгоград</li>
              <li>ул. Рабоче-Крестьянская, 9</li>
              <li>8-й этаж, кабинет 801</li>
              <li>
                <a href="tel:+79610780200" className="hover:text-gray-800 transition-colors">
                  +7 (961) 078-02-00
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 py-6">
          <p className="text-center text-sm text-gray-500">
            © {new Date().getFullYear()} {SITE_NAME}. Все права защищены.
          </p>
        </div>
      </Container>
    </footer>
  )
}
